<template>
  <section id="match-venue" class="match-follow-section">
    <div class="follow-title">
      <img :src="matchFollowSectionData.titleImage" alt="关注我们" />
    </div>

    <div class="follow-list">
      <div v-for="item in matchFollowSectionData.items" :key="item.id" class="follow-card">
        <img class="follow-card-background" :src="matchFollowSectionData.cardImage" alt="" />
        <img class="follow-qrcode" :src="item.qrcode" :alt="item.label" />
        <img class="follow-card-decoration" :src="matchFollowSectionData.decorationImage" alt="" />
        <div class="follow-card-label">{{ item.label }}</div>
      </div>
    </div>
  </section>
</template>

<script>
import { matchFollowSectionData } from '@/data/match/matchFollow'

export default {
  name: 'MatchFollowSection',
  data() {
    return { matchFollowSectionData }
  },
}
</script>

<style scoped lang="scss">
.match-follow-section {
  min-height: 5.625rem;
  padding-top: 0.317708rem;
  background: #eef1f3 url('@/assets/image/match/pc/match/ss.png') center top no-repeat;
  background-size: cover;
  box-sizing: border-box;

  .follow-title {
    width: 6.880208rem;
    height: 0.875rem;
    margin: 0 auto;

    img {
      display: block;
      width: 6.880208rem;
      height: 0.875rem;
      object-fit: contain;
    }
  }

  .follow-list {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    width: 7.104167rem;
    height: 1.916667rem;
    margin: 0.364583rem auto 0;
  }

  .follow-card {
    position: relative;
    width: 1.739583rem;
    height: 1.916667rem;

    .follow-card-background {
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      width: 1.739583rem;
      height: 1.625rem;
    }

    .follow-qrcode {
      position: absolute;
      top: 0.364583rem;
      left: 0.421875rem;
      display: block;
      width: 0.895833rem;
      height: 0.895833rem;
    }

    .follow-card-decoration {
      position: absolute;
      top: 1.333333rem;
      left: 0.088542rem;
      display: block;
      width: 1.578125rem;
      height: 0.583333rem;
      pointer-events: none;
    }

    .follow-card-label {
      position: absolute;
      top: 1.494792rem;
      left: 0;
      width: 1.739583rem;
      height: 0.135417rem;
      color: #ffffff;
      font-size: 0.114583rem;
      font-weight: bold;
      line-height: 0.135417rem;
      text-align: center;
    }
  }
}

@media (max-width: 750px) {
  .match-follow-section {
    min-height: auto;
    padding: 8vw 0 10vw;
    background: transparent;

    .follow-title {
      width: 90%;
      height: auto;

      img {
        width: 100%;
        height: auto;
      }
    }

    .follow-list {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      width: 94%;
      height: auto;
      margin: 6vw auto 0;
    }

    .follow-card {
      width: 29vw;
      height: 32vw;
      flex: none;

      .follow-card-background {
        width: 29vw;
        height: auto;
      }

      .follow-qrcode {
        top: 5.945vw;
        left: 7.0325vw;
        width: 14.935vw;
        height: 14.935vw;
      }

      .follow-card-decoration {
        top: 22.2575vw;
        left: 1.45vw;
        width: 26.1vw;
        height: auto;
      }

      .follow-card-label {
        top: 24.94vw;
        width: 29vw;
        height: auto;
        font-size: 1.9575vw;
        line-height: 2.61vw;
      }
    }
  }
}
</style>
